export default __webpack_public_path__ + "static/media/Fuel.935838c7.svg";